import React, { lazy } from 'react';

// @create-index

export { default as AQIAssetEditPage } from "./AQIAssetEditPage";
export { default as AQIAirvedaEditPage } from "./AQIAirvedaEditPage";
export { default as AppRoutes } from "./AppRoutes";
export { default as AssetPage } from "./AssetPage";
export { default as AssetCheckerPage } from "./AssetCheckerPage";

export { default as AssetsPage } from "./AssetsPage";
export { default as AuthRoutes } from "./AuthRoutes";
export { default as CalendarAssetEditPage } from "./CalendarAssetEditPage";
export { default as ChangePasswordPage } from "./ChangePasswordPage";
export { default as ChangeEmailPage } from "./ChangeEmailPage";
export { default as DataAssetEditPage } from "./DataAssetEditPage";
export { default as DeviceSchedulePage } from "./DeviceSchedulePage";
export { default as DeviceScreenShotsPage } from "./DeviceScreenShotsPage";
export { default as DevicesPage } from "./DevicesPage";
export { default as LoginPage } from "./LoginPage";
export { default as LoginLink } from "./LoginLink";
export { default as Main } from "./Main";
export { default as NotificationsListPage } from "./NotificationsListPage";
export { default as PasswordResetConfirmPage } from "./PasswordResetConfirmPage";
export { default as PasswordResetPage } from "./PasswordResetPage";
export { default as PlaylistPage } from "./PlaylistPage";
export { default as PlaylistsPage } from "./PlaylistsPage";
export { default as ChannelPage } from "./ChannelPage";
export { default as ChannelsPage } from "./ChannelsPage";
export { default as PreviewPage } from "./PreviewPage";
export { default as ChannelPreviewPage } from "./ChannelPreviewPage";
export { default as TickerSeriesListPage } from "./TickerSeriesListPage";
export { default as TickerSeriesPage } from "./TickerSeriesPage";
export { default as URLAssetEditPage } from "./URLAssetEditPage";
export { default as UserProfilePage } from "./UserProfilePage";
export { default as WebAssetEditPage } from "./WebAssetEditPage";
export { default as FidsAssetEditPage } from "./FidsAssetEditPage";
export { default as ClientUserListPage } from "./ClientUserListPage";
export { default as ClientUserCreatePage } from "./ClientUserCreatePage";
export { default as HtmlEditorPage } from "./HtmlEditorPage";
export { default as AppPage } from "./AppPage";
export { default as TemplatePage } from "./TemplatePage";
export { default as ReportsPage } from "./ReportsPage";
export { default as HostAppsPage } from "./HostAppsPage";
export { default as HostAppsPage2 } from "./HostAppsPage2";
export { default as HostPage } from "./HostPage";
export { default as TvHostPage } from "./TvHostPage";
export {default as ReportDownloadLinkPage } from "./ReportDownladLinkPage";



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/index.js